import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateFeed } from '../../../api/feeds';
import { routes } from '../../../constants/RouterPath';
import { createRequest } from '../../../helpers/api/createRequest';
import { Thunk } from '../../../helpers/redux/Thunk';
import { history } from '../../../store/history';
import { FeedBodyWithId } from '../../../types/Endpoints/feeds';
import { TypesIcon } from '../../../types/TypesIcon';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { addNotification } from '../../notifications';

export const UPDATE_FEED = 'feeds/getFeed';

const onSuccess = (): Thunk => dispatch => {
    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Фид обновлен успешно',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));

    history.push(routes.feeds);
};

export const updateFeedThunk = createAsyncThunk(
    UPDATE_FEED,
    createRequest({
        type: UPDATE_FEED,
        loader: async (body: FeedBodyWithId) => updateFeed(body),
        onSuccess,
    }),
);
